import { OktaAuth } from '@okta/okta-auth-js';

import okta from '../config/okta';
import { debugLog } from "./app";

class Auth {
  constructor() {
    this.okta = new OktaAuth(okta.oktaClientConfig);

    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.setValues = this.setValues.bind(this);
    this.getIdToken = this.getIdToken.bind(this);
    this.getProfile = this.getProfile.bind(this);
    this.getBasicProfile = this.getBasicProfile.bind(this);
  }

  async isAuthenticated() {
    return await this.okta.isAuthenticated();
  }

  getIdToken() {
    return this.idToken;
  }

  getProfile() {
    return this.profile;
  }

  getBasicProfile() {
    return {
      name: this.profile.name,
      email: this.profile.email,
      deltaId: this.profile.deltaId
    }
  }

  async handleAuthentication() {
    try {
      if(await this.okta.isAuthenticated()) {
        return { status: true };
      } else if(this.okta.isLoginRedirect()) {
        debugLog('need to parse login');
        const response = await this.okta.handleLoginRedirect();
        debugLog('Response: ', response);
        this.okta.tokenManager.setTokens(response.tokens);
        return { status: true };
      } else if (window.location.hash) {
        // TODO handle errors like user doesn't have app
        debugLog('Parsed: ', await this.okta.token.parseFromUrl());
      } else {
        debugLog('need to redirect');
        this.okta.token.getWithRedirect();
      }
    } catch (e) {
      console.error(e);
      return { status: false, message: e.message }
    }
  }

  setValues(response) {
    this.idToken = response.idToken;
    this.expiresAt = response.expiresAt * 1000;
    this.profile = response.claims;
  }

  async handleSignOut() {
    try {
      // TODO okta-auth-js@3 changed this.okta.signOut() to clear tokens
      await this.okta.tokenManager.clear();
      return { status: true };
    } catch (e) {
      this.error = e;
      return { status: false, message: e.message };
    }
  }
}

const oktaClient = new Auth();

export default oktaClient;